<template>
  <v-dialog :value="dialogProp.show" persistent max-width="800">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование торговой процедуры') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <lot-edit-info
            ref="lotInfo"
            :lot-info="dialogProp.lot"
            :loading="isLoading"
            :save-method="updateLotInfo"
            @keydown.native.enter="focusOnBtn('continueBtn')" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            ref="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import LotEditInfo from '@/components/reused/lot/LotEditInfo.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions } from 'vuex'
  import { LOT_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      LotEditInfo
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            lot: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
    },
    methods: {
      ...mapActions(LOT_MANAGEMENT.NAMESPACE, {
        updateLotInfoAction: LOT_MANAGEMENT.ACTIONS.UPDATE_LOT_INFO
      }),
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.lotInfo.validateAndSave()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      },
      updateLotInfo: async function (lot) {
        this.isLoading = true
        try {
          await this.updateLotInfoAction({
            lot,
            lotId: this.dialogProp.lot.lotId,
            lotType: this.dialogProp.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          //  пробрасываем ошибку чтобы не закрывать диалог
          throw error
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
